import React from 'react'

const SvgContacts = (props: any) => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M4 4h24v24H4z" />
      <path
        d="M6 26a8 8 0 1116 0h-2a6 6 0 10-12 0H6zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm8.284 3.703A8.002 8.002 0 0127 26h-2v-.001a6.001 6.001 0 00-3.538-5.472l.82-1.824h.002zm-.688-11.29A5.5 5.5 0 0125 12.5a5.499 5.499 0 01-5 5.478v-2.013a3.5 3.5 0 001.041-6.609l.555-1.943z"
        fillOpacity={0.64}
        fill="#191923"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgContacts
